export default __webpack_public_path__ + "static/media/Programate-academy-negros.07a126b8.png";